import { useMaterialsQuery } from '@/app/hooks/useMaterialsQuery'
import { Spinner } from '@/view/components/ui/spinner'
import { useMemo } from 'react'
import { MaterialsContainer } from './components/MaterialsContainer'

export default function Materials() {
  const { data, isLoading, isPending, error } = useMaterialsQuery({
    search: '',
  })

  const materials = useMemo(() => data?.materials ?? [], [data?.materials])

  if (isLoading || isPending)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner />
      </div>
    )

  if (!materials || materials.length === 0) return null
  if (error) return <div>Error</div>

  return <MaterialsContainer materials={materials} />
}
